import { OPEN_MODAL, CLOSE_MODAL } from "/@src/redux/contants";

const INIT_STATE = {
  modals: [],
};

const modalReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case OPEN_MODAL:
      const { id } = action.payload;
      let currentModals = [];
      const foundIndex = state.modals.findIndex((item) => item.id === id);

      // If the modal with matching id exists, update isOpen property
      if (foundIndex !== -1) {
        const newArr = [...state.modals];
        newArr[foundIndex] = { ...action.payload, isOpen: true };
        currentModals = newArr;
      } else {
        // If the modal with matching id does not exist, add a new modal with isOpen: true
        currentModals = [...state.modals, { ...action.payload, isOpen: true }];
      }

      return { modals: currentModals };
    case CLOSE_MODAL:
      // Update isOpen property of the modal with the specified id to false
      const nextModals = state.modals.map((modal) => {
        return modal.id === action.payload
          ? { ...modal, isOpen: false }
          : modal;
      });
      return { modals: nextModals };
    default:
      return { ...state };
  }
};

export default modalReducer;
